export default "__VITE_ASSET__lPOHSIdG__"